const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  faceSizeSelection: 'face-size-selection',
  startTryOn: 'start-try-on',
  VMMVAvailability: 'vmmv-availability',
  searchSubmit: 'search-submit',
  facetsUpdate: 'facets-update',
  newsletterSubscription: 'newsletter-subscription',
  wishlistAdd: 'wishlist-add',
  plpProductsLoaded: 'plp-products-loaded',
};

const FACE_SIZE_RANGE = {
  narrow: { key: 'narrow', min: 111, max: 128 },
  average: { key: 'average', min: 123, max: 138 },
  wide: { key: 'wide', min: 133, max: 150 }
}